import { render, staticRenderFns } from "./DrayageList.vue?vue&type=template&id=a87e1972&scoped=true"
import script from "./DrayageList.vue?vue&type=script&lang=js"
export * from "./DrayageList.vue?vue&type=script&lang=js"
import style0 from "./DrayageList.vue?vue&type=style&index=0&id=a87e1972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87e1972",
  null
  
)

export default component.exports